import React, { Fragment, useContext } from 'react';
import context from '../../context';
import styled from 'styled-components';
import { Row, Col } from 'react-bootstrap';
import { chunkArray } from '../../util';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { v1 as uuid } from 'uuid';

import PropertyCard from '../cards/property-carrousel';

/* Contenedor centrado con 85% del ancho */
const Wrapper = styled.div`
  width: 85%;
  margin: 0 auto; /* 7.5% a izquierda y derecha */
  position: relative; /* necesario para los botones */
`;

const SliderCustom = styled(Slider)`
  padding-bottom: 1.5rem;
`;

const ButtonBackCustom = styled(ButtonBack)`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${props => props.theme.primaryColor};
  transition: 250ms ease;
  border: none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: -2rem; /* ajustado para 85% */
  color: #fff;
  &:hover {
    filter: brightness(1.1);
  }
`;

const ButtonNextCustom = styled(ButtonNext)`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${props => props.theme.primaryColor};
  transition: 250ms ease;
  border: none;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: absolute;
  top: 50%;
  right: -2rem; /* ajustado para 85% */
  &:hover {
    filter: brightness(1.1);
  }
`;

export default () => {
  const state = useContext(context);
  const items = state.featuredProperties;

  // ✅ Siempre 3 propiedades por slide en tablet y desktop
  const chunkedItemsTablet = chunkArray(items.map(item => item), 3);
  const chunkedItemsDesktop = chunkArray(items.map(item => item), 3);

  return (
    <Wrapper>
      {/* Mobile: 1 propiedad por slide */}
      <CarouselProvider
        naturalSlideWidth={100}
        isIntrinsicHeight={true}
        totalSlides={items.length}
        visibleSlides={1}
        orientation="horizontal"
        interval={5000}    // ⬅️ avanza cada 5 segundos
        isPlaying={true}   // ⬅️ autoplay activado
        infinite={true}    // ⬅️ vuelve a empezar en loop
        className="d-md-none d-lg-none d-xl-none"
      >
        <SliderCustom>
          {items.map((item, index) => (
            <Slide key={item.id} index={index}>
              <PropertyCard {...item} />
            </Slide>
          ))}
        </SliderCustom>
      </CarouselProvider>

      {/* Tablet: 3 propiedades por slide */}
      <CarouselProvider
        naturalSlideWidth={100}
        isIntrinsicHeight={true}
        totalSlides={chunkedItemsTablet.length}
        visibleSlides={1}
        orientation="horizontal"
        interval={5000}
        isPlaying={true}
        infinite={true}
        className="d-none d-md-block d-lg-none"
      >
        <SliderCustom>
          {chunkedItemsTablet.map((mainItem, index) => (
            <Slide key={uuid()} index={index}>
              <Row>
                {mainItem.map(item => (
                  <Col xs={12} md={4} key={item.id}>
                    <PropertyCard {...item} />
                  </Col>
                ))}
              </Row>
            </Slide>
          ))}
        </SliderCustom>
        <ButtonBackCustom>
          <LeftOutlined />
        </ButtonBackCustom>
        <ButtonNextCustom>
          <RightOutlined />
        </ButtonNextCustom>
      </CarouselProvider>

      {/* Desktop: 3 propiedades por slide */}
      <CarouselProvider
        naturalSlideWidth={100}
        isIntrinsicHeight={true}
        totalSlides={chunkedItemsDesktop.length}
        visibleSlides={1}
        orientation="horizontal"
        interval={5000}
        isPlaying={true}
        infinite={true}
        className="d-none d-lg-block"
      >
        <SliderCustom>
          {chunkedItemsDesktop.map((mainItem, index) => (
            <Slide key={uuid()} index={index}>
              <Row>
                {mainItem.map(item => (
                  <Col xs={12} md={4} key={item.id}>
                    <PropertyCard {...item} />
                  </Col>
                ))}
              </Row>
            </Slide>
          ))}
        </SliderCustom>
        <ButtonBackCustom>
          <LeftOutlined />
        </ButtonBackCustom>
        <ButtonNextCustom>
          <RightOutlined />
        </ButtonNextCustom>
      </CarouselProvider>
    </Wrapper>
  );
};